import * as React from 'react';
import type {AppProps} from 'next/app';
import {CacheProvider, EmotionCache} from '@emotion/react';
import {CssBaseline} from '@mui/material';

import {deDE} from '@mui/x-date-pickers/locales';

import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'

import createEmotionCache from '../utility/createEmotionCache';
import '../theming/globals.css';
import '../theming/fonts.css';
import {SosThemeProvider} from "../theming/ThemeContext";
//import client from "../utility/createApolloClient";
import {ApolloClient, ApolloProvider, DefaultOptions, HttpLink, InMemoryCache} from "@apollo/client";
import possibleTypes from '../../packages/graphql-layer/src/__downloaded__/possibleTypes.json';
import {CartProvider} from "../context/CartContext";
import {SessionProvider} from "../context/SessionContext";
import Usercentrics from "../extenions/usercentrics/Usercentrics";
import {useScrollToAnchor} from "../utility/useScrollToAnchor";

interface MyAppProps extends AppProps {
    emotionCache?: EmotionCache;
    previewMode?: boolean;
    e2eTestMode?: boolean;
}

const clientSideEmotionCache = createEmotionCache();
const defaultOptions: DefaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
}

const client = new ApolloClient({
    link: new HttpLink({
        uri: '/api/raeQl'
    }),
    cache: new InMemoryCache({
        possibleTypes: possibleTypes,
        typePolicies: {
            Query: {
                fields: {
                    content: {
                        merge(existing, incoming) {
                            return incoming;
                        }
                    },
                },
            },
        }
    }),
    defaultOptions: defaultOptions
});


const MyApp: React.FunctionComponent<MyAppProps> = (props) => {
    const {Component, emotionCache = clientSideEmotionCache, pageProps, previewMode, e2eTestMode} = props;
    useScrollToAnchor();

    return (
        <CacheProvider value={emotionCache}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='de' localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText}>
                <SosThemeProvider>
                    <SessionProvider>
                        <CartProvider>
                            <ApolloProvider client={client}>
                                <CssBaseline/>
                                <Component {...pageProps} />
                                {!(e2eTestMode || previewMode) && <Usercentrics pageProps={pageProps}/>}
                            </ApolloProvider>
                        </CartProvider>
                    </SessionProvider>
                </SosThemeProvider>
            </LocalizationProvider>

        </CacheProvider>
    );
};

export default MyApp;